/* eslint-disable @next/next/no-img-element, prettier/prettier */
import React from 'react';
import ImageGallery from 'react-image-gallery';
import imageService from '@/services/image-service';
import styles from './Media.module.scss';
import type * as Types from '@/stores/productsApiTypes';
import 'react-image-gallery/styles/css/image-gallery.css';

export const Media = ({ media = [] }: { media: Types.Media[] }) => {
  const mediaItems = media.filter(Boolean).map((mediaItem: Types.Media, idx: number) => {
    const imageUrl = imageService.getUrl(mediaItem.src, 200, 200, true);
    const isFirst = idx === 0;
    return {
      loading: isFirst ? 'eager' : 'lazy',
      original: imageUrl,
      originalAlt: mediaItem.alt ?? '',
      originalHeight: 200,
      originalWidth: 200
    };
  });

  return (
    <div className={styles.mediaCarousel}>
      <ImageGallery
        disableKeyDown={true}
        infinite={false}
        items={mediaItems}
        showBullets={mediaItems.length > 1}
        showFullscreenButton={false}
        showPlayButton={false}
        showThumbnails={false}
        onBulletClick={(e: any) => {
          e.stopPropagation();
          e.preventDefault();
        }
      }
      />
    </div>
  );
};
